<!--
 * @Author: your name
 * @Date: 2020-06-29 11:14:16
 * @LastEditTime: 2020-06-30 22:57:54
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /maintain-web/src/view/DataAnalysis/Index.vue
-->
<template>
  <div class="main-area">
    <div v-if="$route.meta.rank == 2">
      <el-breadcrumb separator=":">
        <el-breadcrumb-item>当前位置</el-breadcrumb-item>
        <el-breadcrumb-item>大数据分析</el-breadcrumb-item>
      </el-breadcrumb>
      <el-row class="margin-top-10">
        <el-col
          :span="6"
          class="margin-top-10">
          <el-date-picker
            v-model="searchForm.updateTime"
            :size="GLOBAL.config.systemSize"
            type="datetimerange"
            align="right"
            unlink-panels
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 100%;"/>
        </el-col>
        <el-col
          :span="2"
          class="margin-top-10">
          <!-- <el-button type="primary" @click="doSearch" :size="GLOBAL.config.systemSize" icon="el-icon-search">查询
                    </el-button> -->
        </el-col>
      </el-row>
      <div class="box">
        <el-button
          type="primary"
          @click="$router.push({path:'/dataAnalysis/analyze'})">抽厕分析</el-button>
        <el-button
          type="primary"
          @click="$router.push({path:'/dataAnalysis/Maintenance'})">维修分析</el-button>
        <el-button
          type="primary"
           @click="$router.push({path:'/dataAnalysis/wcAnalysis'})"
        >作业量分析</el-button>
        <el-button type="primary"
         @click="$router.push({path:'/dataAnalysis/SatisfactionAnalysis'})">满意度排行</el-button>
        <el-button type="primary">一键导入</el-button>
      </div>
    </div>
    <div v-else><router-view/></div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      // 查询表单
      searchForm: {
        updateTime: ''
      },
      tableData: [
      ],
      loading: false
    }
  },
  watch: {},
  computed: {},
  methods: {
    zylfx () {
      this.$router.push({
        name: 'analyze',
        params: {
        }
      })
    }
  },
  created () {},
  mounted () {}
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/view/DataAnalysis/Index.vue